import Component from '@glimmer/component'
import HomeschoolBaseTile from 'teacher-ui-client/components/home/tiles/homeschool/base-tile'
import { t } from 'ember-intl'
import { TileButton } from 'teacher-ui-client/components/home/tiles/homeschool/button'
import familyDashboard from '@images/homeschool-ui-icons/family_dashboard.svg'
import type LogoutService from 'teacher-ui-client/services/logout'
import { service } from '@ember/service'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'

export class FamilyDashboardTile extends Component<unknown> {
  @service logout!: LogoutService

  logoutAndRedirectToFamilyDashboard = () => {
    void this.logout.logoutAndRedirectToReadingeggs('/parent_ui/redirect/home')
  }

  <template>
    <HomeschoolBaseTile
      @themeKey={{ThemeKeys.orange}}
      @imgSrc={{familyDashboard}}
      @imgAlt={{t "pages.home.panels.homeschool.familyDashboard.imageAlt"}}
      @title={{t "pages.home.panels.homeschool.familyDashboard.title"}}
      @tileDescription={{t "pages.home.panels.homeschool.familyDashboard.description" htmlSafe=true}}
    >
      <div class="flex flex-col items-center space-y-4 text-center">
        <TileButton
          @title={{t "pages.home.panels.homeschool.familyDashboard.buttonText"}}
          @themeKey={{ThemeKeys.orange}}
          @action={{this.logoutAndRedirectToFamilyDashboard}}
          data-test-homeschool-family-dashboard-button
        />
      </div>
    </HomeschoolBaseTile>
  </template>
}

export default FamilyDashboardTile
